export const NodeTypeEnum = {
  LORAWAN: 0,
  API: 1,
  MQTT: 2,
  NODERED: 3,
  SPARKPLUG: 4,
  SPOTIO: 5,
  MODBUS: 6,
};

export function nodeTypeToString(nodeType: number): string {
  switch (nodeType) {
    case NodeTypeEnum.LORAWAN:
      return "LoRaWAN";
    case NodeTypeEnum.API:
      return "API";
    case NodeTypeEnum.MQTT:
      return "MQTT";
    case NodeTypeEnum.NODERED:
      return "Node-RED";
    case NodeTypeEnum.SPARKPLUG:
      return "Sparkplug";
    case NodeTypeEnum.SPOTIO:
      return "SpotIO";
    case NodeTypeEnum.MODBUS:
      return "Modbus";
    default:
      return "Unknown";
  }
}

export const NodeTypeOptions = [
  { value: NodeTypeEnum.LORAWAN, label: "LoRaWAN" },
  { value: NodeTypeEnum.API, label: "API" },
  { value: NodeTypeEnum.MQTT, label: "MQTT" },
  { value: NodeTypeEnum.NODERED, label: "Node-RED" },
  { value: NodeTypeEnum.SPARKPLUG, label: "Sparkplug" },
  { value: NodeTypeEnum.SPOTIO, label: "SpotIO" },
  { value: NodeTypeEnum.MODBUS, label: "Modbus" },
];

export const DataSourceTypeMap = {
  0: "API",
  1: "MQTT",
  2: "Sparkplug",
  3: "Script",
  4: "Integration",
  5: "Nordpool",
  6: "SpotIO",
  7: "Modbus",
  8: "OPC",
  9: "Formula",
};

export function getDataSourceTypeName(type: number): string {
  return DataSourceTypeMap[type as keyof typeof DataSourceTypeMap] || "Unknown";
}

export const ScriptTypeEnum = {
  LOOPING: 0,
  INVOKED: 1,
  TRIGGERED: 2,
};

export const ScriptLogCategoryEnum = {
  INFORMATION: 0,
  ERROR: 1,
};

export function scriptTypeToString(scriptType: number): string {
  switch (scriptType) {
    case ScriptTypeEnum.LOOPING:
      return "Looping Script";
    case ScriptTypeEnum.INVOKED:
      return "Invoked Script";
    case ScriptTypeEnum.TRIGGERED:
      return "Triggered Script";
    default:
      return "Unknown";
  }
}
